export const BUILD_ITEMS = {
  SINGLE_QUANTITY_TEXT: 'Single Quantity Item',
  SINGLE_QUANTITY_SUBTEXT: 'Can only be claimed by a single participant',
  MULTIPLE_QUANTITY_TEXT: 'Multi Quantity Item',
  MULTIPLE_QUANTITY_SUBTEXT: 'Can be claimed by multiple participants',
  CUSTOM_PRICE_TEXT: 'Custom Price Item',
  CUSTOM_PRICE_SUBTEXT: 'Set a price range to participate',
  Volunteer_TEXT: 'Add Volunteer Item',
  Volunteer_SUBTEXT: 'Customize your Activity Details',
} as const;

export const Notification_STRINGS = {
    CUSTOMIZE_EMAIL_TEXT: 'Customize Email Message for your Participants',
    CUSTOMIZE_EMAIL_EDITOR_PLACEHOLDER:'Add your note here...',
    CUSTOMIZE_EMAIL_BUTTON:'Customize Email for Participants',
} as const;
